import React, {useState} from "react";

import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

const languageMap = {
    en: {label: "English"},
    fr: {label: "Français"},
    nl: {label: "Nederlands"}
};

const LanguageSelect = (props) => {
    let [selected, setSelected] = useState(props.defaultLanguage);

    const [menuAnchor, setMenuAnchor] = React.useState(null);

    return (
        <div className="d-flex justify-content-end align-items-center language-select-root language-select">
            <Button onClick={({currentTarget}) => {
                setMenuAnchor(currentTarget)
            }}>
                {selected}
                <ArrowDropDown fontSize="small"/>
            </Button>
            <Popover
                open={!!menuAnchor}
                anchorEl={menuAnchor}
                onClose={() => setMenuAnchor(null)}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right"
                }}
            >
                <div>
                    <List>

                        {Object.keys(languageMap)?.map(item => (
                            <ListItem
                                button
                                key={item}
                                onClick={() => {
                                    setSelected(languageMap[item].label)
                                    setMenuAnchor(null);
                                    props.actionHandler(item)
                                }}
                            >
                                {languageMap[item].label}
                            </ListItem>
                        ))}
                    </List>
                </div>
            </Popover>
        </div>
    );
};

export default LanguageSelect;
